import { CopyLinkText } from 'owa-locstrings/lib/strings/copylinktext.locstring.json';
import { CopyToClipboardPromptText } from 'owa-locstrings/lib/strings/copytoclipboardprompttext.locstring.json';
import { CopyToClipboardMacPromptText } from 'owa-locstrings/lib/strings/copytoclipboardmacprompttext.locstring.json';
import loc, { isStringNullOrWhiteSpace } from 'owa-localize';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';

import { isMac } from 'owa-user-agent/lib/userAgent';

function copyLinkToClipboard(openUrl: string) {
    const text = isMac() ? loc(CopyToClipboardMacPromptText) : loc(CopyToClipboardPromptText);
    window.prompt(text, openUrl);
}

export function getCopyLinkContextMenuItem(anchorElement: HTMLAnchorElement): IContextualMenuItem {
    if (isStringNullOrWhiteSpace(anchorElement.href)) {
        return null;
    }

    return {
        name: loc(CopyLinkText),
        key: 'CopyLink',
        onClick: () => {
            copyLinkToClipboard(anchorElement.href);
            logUsage('AttachmentLinkViewCopyLink');
        },
    };
}
